import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { tenantSlugFromPath } from '../utils/tenant-path.util';

/**
 * The public marketing homepage lives at router path '' — but so does a bare
 * workspace root (/w/<slug>), because APP_BASE_HREF strips the /w/<slug>
 * prefix before the router ever sees the URL (see app.config.ts). Without this
 * guard, visiting /w/<slug> with no further path would show the marketing
 * page instead of redirecting into that workspace's dashboard.
 */
export const landingGuard: CanActivateFn = () => {
  if (tenantSlugFromPath()) {
    return inject(Router).createUrlTree(['dashboard']);
  }
  return true;
};
